export default "__VITE_ASSET__61cc0433__"